module.exports = __webpack_public_path__ + "fonts/NunitoSans-ExtraBold.7090a0b.woff2";